import { useEffect, useState } from "react";
import { Alert, Button, Form, InputGroup } from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import authApi from "services/apis/authApi";
import StorageManager from "utils/storageManager";
import ROUTES from "routes/constant";

const SignIn = () => {
  const [err, setError] = useState("");
  const [latitude, setLatitude] = useState(25.1789312);
  const [longitude, setLongitude] = useState(75.890688);
  const [currentLocation, setCurrentLocation] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [data, setData] = useState({
    password: "",
    username: "",
  });
  const [status, setStatus] = useState(false);

  const getLocationAndPostData = async () => {
    if (!navigator.geolocation) {
      alert("GeoLocation is not supported by your browser");
    } else {
      navigator.geolocation.getCurrentPosition(
        async function (position) {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);

          const geoUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=en`;

          const response = await fetch(geoUrl);
          const data = await response.json(); // parses JSON response into native JavaScript objects
          const locationArr = [
            data?.city,
            data?.locality,
            data?.principalSubdivision,
            data?.principalSubdivisionCode,
            data?.countryName,
            data?.countryCode,
            data?.postcode,
            data?.continent,
            data?.continentCode,
          ];

          setCurrentLocation(locationArr.filter((e) => e.trim()).join(" "));
        },
        function (error) {
          console.log(error);
        }
      );
    }
  };

  useEffect(() => {
    getLocationAndPostData();
  }, []);

  const { password, username } = data;

  const changeHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  let navigate = useNavigate();

  const onLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await authApi.loginAdmin({
        ...data,
        latitude,
        longitude,
        location: currentLocation,
      });
      StorageManager.set("otpSentTime", moment().toISOString());
      if (res.data.status === 0) {
        navigate(ROUTES.AUTH.LOGIN_OTP, {
          state: {
            ...data,
            latitude,
            longitude,
            location: currentLocation,
          },
        });
      } else {
        setStatus(true);
      }
    } catch (err) {
      console.log(err);
      setError("Something went wrong");
    }
  };

  const jwt_token = localStorage.getItem("token");
  return (
    <>
      {jwt_token ? (
        <Navigate to={`/dashboard`} />
      ) : (
        <>
          {err && <Alert variant="danger">{err}</Alert>}
          <Form onSubmit={onLogin}>
            <h5 className="text-start mb-2">Sign in to Your Account</h5>
            <p className="mb-4 text-muted tx-13 ms-0 text-start">
              {/* Signin to create, discover and connect with the global
                              community */}
            </p>
            <Form.Group className="text-start form-group" controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                placeholder="Enter your email"
                name="username"
                type="text"
                value={username}
                onChange={changeHandler}
                required
                className="form-control"
              />
            </Form.Group>

            <Form.Group
              className="text-start form-group"
              controlId="formpassword"
            >
              <Form.Label>Password</Form.Label>
              <InputGroup>
                <Form.Control
                  placeholder="Enter your password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={changeHandler}
                  required
                  aria-label="Enter your password"
                  aria-describedby="basic-addon2"
                  className="form-control"
                />
                <InputGroup.Text id="basic-addon2" className="bg-transparent">
                  <span
                    style={{
                      width: "20px",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={`${
                        !showPassword
                          ? "fa-regular fa-eye"
                          : "fa-regular fa-eye-slash"
                      }`}
                    ></i>
                  </span>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            {status ? (
              <h6 className="text-danger" style={{ height: "35" }}>
                Please Enter Correct Email and Password
              </h6>
            ) : (
              <h6
                style={{
                  height: "35",
                  visibility: " hidden",
                }}
              >
                correct
              </h6>
            )}
            <Button
              className="btn ripple btn-main-primary btn-block mt-2"
              type="submit"
            >
              Sign In
            </Button>
          </Form>
          <div className="text-start mt-5 ms-0">
            <div className="mb-1">
              <Link to={ROUTES.AUTH.FORGOT_PASSWORD}>Forgot password ?</Link>
            </div>
            <div></div>
          </div>
        </>
      )}
    </>
  );
};

export default SignIn;
